import React from 'react';



export class FooterContacts extends React.Component {
    render() {
        return (
            <>
                <ul className="footer-contacts">
                    <li className="footer-contacts__item" key='footer-contacts-phone'>
                        <p className="footer-contacts__label footer-contacts__label--phone">
                            Наш телефон
                        </p>
                    
                        <div style={{
                            position: 'relative',
                            fontSize: 16,
                            height: 23,
                        }}>
                             <svg className="footer-contacts__icon" width="16" height="16">
                                <use xlinkHref="/images/sprite.svg#icon--phone" />
                            </svg>
                            <a href="tel:+375(44)748-08-23" style={{marginLeft: 20}}>+375(44)748-08-23</a>
                        </div>

                    </li>
                    <li className="footer-contacts__item" key='footer-contacts-email'>
                        <p className="footer-contacts__label footer-contacts__label--email">
                            E-mail
                        </p>
                        <div style={{
                            position: 'relative',
                            fontSize: 16,
                            height: 23,
                        }}>
                            <svg className="footer-contacts__icon" width="23" height="16">
                                <use xlinkHref="/images/sprite.svg#icon--email" />
                            </svg>
                            <a href="mailto:a.berezneva@sellwin.by" style={{marginLeft: 30}}>a.berezneva@sellwin.by</a>
                        </div>
                    </li>
                </ul>
            </>
        )
    }
}
